/**
 * Main theme JavaScript file.
 *
 * This file is the entry point for the Webpack build process.
 * It should be used to import and initialize other JavaScript modules.
 */

// 1. Import modules/components.
// import MobileMenu from './components/MobileMenu';
// import SmoothScroll from './components/SmoothScroll';
import LogoInjector from './components/LogoInjector.js';
// import ExampleComponent from './components/ExampleComponent'; // Uncomment to use

/**
 * The main function to run on DOMContentLoaded.
 * This is where you initialize all your components.
 */
const main = () => {
	// Initialize other components here.
	const logoInjector = new LogoInjector( '.js-logo-container' );
	logoInjector.init();
};

// 3. Run the main function when the DOM is ready.
// This ensures that all elements are available before your scripts try to interact with them.
if ( document.readyState === 'complete' || document.readyState === 'interactive' ) {
	main();
} else {
	document.addEventListener( 'DOMContentLoaded', main, false );
}
